<template>
  <div>
    <v-data-table
      disable-pagination
      style="width: 100%"
      :headers="headers"
      :items="promotions"
      :pagination.sync="pagination"
      :loading="loading"
      class="elevation-1"
      hide-default-footer
    >
      <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
      <template v-slot:item="props">
        <tr v-on:click.stop="goToPromotion(props.item.id)">
          <td style="width:16%;">{{props.item.name}}</td>
          <td style="width:54%;">{{props.item.description}}</td>
          <td style="width:20%;">
            Start: {{props.item.start_date}}
            <br />
            End: {{props.item.end_date}}
          </td>
          <td style="width:5%;">{{discount(props.item)}}</td>
          <td style="width:5%;">{{props.item.enabled}}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "promotions_list",
  props: {
    promotions: Array,
    paginationProp: Object,
    loading: Boolean
  },
  data: function() {
    return {
      pagination: this.paginationProp,
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Description",
          align: "left",
          sortable: false,
          value: "description"
        },
        {
          text: "Duration",
          align: "left",
          sortable: false,
          value: "duration"
        },
        {
          text: "Discount",
          align: "left",
          sortable: false,
          value: "discount"
        },
        {
          text: "Enabled",
          align: "left",
          sortable: false,
          value: "enabled"
        }
      ]
    };
  },
  methods: {
    goToPromotion: function(id) {
      this.$router.push(`/settings/promotion/edit/${id}`);
    },
    doNothing: function() {},
    discount: function(promotion) {
      if (promotion.discount_type == "percentage") {
        return promotion.discount_percentage + "%";
      } else if (promotion.discount_type == "fixed_amount") {
        return "£" + promotion.discount_fixed / 100;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 3px !important;
}

thead th:not(:first-child) {
  padding: 0 4px;
}
</style>
